<template>
  <div class="page-container pt-3 pb-4 donation-page">
    <!-- For help on embedding DonorSnap forms go to http://help.donorsnap.com/DonorSnap-Help/default.aspx?pageid=embedding_forms. You may need to adjust the height and width of the form in order for it to be properly displayed. -->
    <iframe
      id="donate-iframe"
      src="https://forms.donorsnap.com/form?id=b39f0ca2-04a9-4a55-9e4f-c5d3a1a94791"
      width="99%"
      frameborder="0"
      style="margin: 5px"
    ></iframe>
  </div>
</template>
<script>
export default {
  metaInfo: function () {
    return {
      title: "Donate",
    };
  },
  mounted() {
    Array.from(document.getElementsByTagName("header")).forEach((el) => {
      el.style.display = "none";
    });
    document.getElementById("player-ui").style.display = "none";
  },
  beforeDestroy() {
    Array.from(document.getElementsByTagName("header")).forEach((el) => {
      el.style.display = "";
    });
    document.getElementById("player-ui").style.display = "";
  },
};
</script>
<style>
/* header {
  display: none !important;
}
#player-ui {
  display: none !important;
} */
</style>

<style scoped>
iframe {
  height: 2800px;
}
@media (max-width: 842px) {
  iframe {
    height: 2800px;
  }
}
</style>